// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cd-4";
export var closeButton = "_cd-6";
export var dismissButton = "_cd-3";
export var editImageWithAiContainer = "_cd-8";
export var imageUploadWrapper = "_cd-7";
export var misspelledWord = "_cd-5";
export var spellCheckContainer = "_cd-2";
export var spin = "_cd-1";
export var spinning = "_cd-0";